let Action;
let _seq = 1;

module.exports = Action = class Action {
  constructor(options) {
    this.seq = _seq++;
    this.source = options.source;
    this.type = options.type;
    this.data = options.data;
  }
  static seq() {
    return _seq;
  }
};
